import Vue from 'vue';
import Vuex from 'vuex';
import project from './modules/project/index';
import floorplans from './modules/floorplans/index';
import neighbourhood from './modules/neighbourhood/index';
import amenities from './modules/amenities/index';
import builder from './modules/builder/index';
import ui from './modules/ui/index';
import user from './modules/user/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    project,
    floorplans,
    neighbourhood,
    builder,
    ui,
    amenities,
    user
  },
  state: {
    appReady: false
  },
  mutations: {
    setAppReady(state) {
      state.appReady = true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js